import React, { useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { MenuItem } from "./CustomMenu";

interface IProps {
  data: MenuItem;
  expandable: boolean;
}

const CustomMenuItem = (props: IProps) => {
  const [show, setShow] = useState(!props.expandable);

  return (
    <>
      <li
        className={
          props.data.isActive
            ? "custom-menu-item-wraper custom-menu-item-wraper-active d-flex justify-content-between"
            : "custom-menu-item-wraper d-flex justify-content-between"
        }
        onClick={() => {
          props.expandable && props.data.expandableData && setShow(!show);
          props.data.onClick();
        }}
      >
        {props.data.expandableData && props.expandable ? (
          <>
            <span>{props.data.text}</span>
            <span>
              <MdKeyboardArrowDown />
            </span>
          </>
        ) : (
          <>{props.data.text}</>
        )}
      </li>
      {props.data.expandableData && show && (
        <li className="custom-menu-item-wraper-expandable">
          {props.data.expandableData}
        </li>
      )}
    </>
  );
};

export default CustomMenuItem;
